import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCash = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.75 7.333c0-.295.257-.583.635-.583h1.824A3 3 0 0 1 3.75 9.209zm0 3.39A4.5 4.5 0 0 0 7.723 6.75h8.555a4.5 4.5 0 0 0 3.972 3.973v2.554a4.5 4.5 0 0 0-3.972 3.973H7.723a4.5 4.5 0 0 0-3.973-3.972zm16.5-1.514V7.333c0-.295-.257-.583-.635-.583h-1.823a3 3 0 0 0 2.458 2.459m1.5 1.541v6.5a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5V6.75a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5v4m-3.959 6.5a3 3 0 0 1 2.459-2.459v1.876c0 .295-.257.583-.635.583zM3.75 14.791v1.876c0 .295.257.583.635.583h1.824a3 3 0 0 0-2.459-2.459M13.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCash;
